import React from 'react';
import { PricingTable, Show, SignIn } from '@clerk/react';
import Header from './components/Header';
import './SignUpPage.css';

function Checkout() {
  return (
    <>
      <Header />
      <div className="dashboard-container">
        <div className="dashboard-placeholder">
          <Show when="signed-out">
            <SignIn forceRedirectUrl="/checkout" />
          </Show>
          <Show when="signed-in">
            <div style={{ width: '100%', maxWidth: 980, margin: '0 auto', padding: '32px 16px' }}>
              <h1 style={{ textAlign: 'center', marginBottom: 8 }}>Choose your plan</h1>
              <p style={{ textAlign: 'center', color: '#5a6c7d', marginBottom: 32 }}>
                One better-informed bid pays for years of access.
              </p>
              <PricingTable forOrganizations={false} newSubscriptionRedirectUrl="/dashboard" />
            </div>
          </Show>
        </div>
      </div>
    </>
  );
}

export default Checkout;
